import { Component, Input, LOCALE_ID, Inject, ElementRef, ViewChild, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { CvNumberLocalizePipe } from "src/app/reusables/pipes/cv-number-localize.pipe";
import { SupervisorService } from "../supervisor.service";
import { ViewType, SupervisorObject } from "../supervisor.model";
import { debounceTime, Subject } from "rxjs";

@Component({
    selector: "cxone-agent-card",
    templateUrl: "./cxone-agent-card.component.html",
    styleUrl: "./cxone-agent-card.component.scss",
})
export class CxoneAgentCardComponent {
    @Input() supervisor: SupervisorObject;
    @Input() supervisorData: SupervisorObject;
    @Output() seeMoreStatus = new EventEmitter<boolean>();
    @Output() agentUpdated = new EventEmitter<any>();
    @Output() agentSelected = new EventEmitter<number>();

    @ViewChild('tooltipLoginName') tooltipLoginName!: ElementRef;
    @ViewChild('tooltipTeam') tooltipTeam!: ElementRef;

    isTextTruncated = false;
    viewType = ViewType;

    searchTerm: string = '';
    filteredSupervisors: SupervisorObject[] = [];

    private searchSubject: Subject<string> = new Subject();

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        public changeDetector: ChangeDetectorRef,
        public cvLocalizationService: CVLocalizationService,
        public cvNumberLocalizePipe: CvNumberLocalizePipe,
        private supervisorService: SupervisorService
    ) {
        this.searchSubject.pipe(debounceTime(300)).subscribe(() => {
            this.applySearchFilter();
        });
    }

    async ngOnInit() {
        await this.loadLocalization();
        this.filteredSupervisors = [this.supervisorData];
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("Games_Module");
        } catch {
            console.error("Failed to load localization for Games");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        return this.cvLocalizationService.getCachedText("Games_Module", key, defaultValue);
    }

    displayTooltip(tooltipFor: string, tooltip: string): string {
        let element = tooltipFor == 'loginName' ? this.tooltipLoginName?.nativeElement : this.tooltipTeam?.nativeElement;
        this.isTextTruncated = element?.scrollWidth > element?.clientWidth;
        return this.isTextTruncated ? tooltip : '';
    }

    retrievedCurrentView() {
        let views: number;
        this.supervisorService.getCurrentView().subscribe(view => {
            views = view;
        });
        return views;
    }

    updatedCurrentView() {
        this.supervisorService.setCurrentView(this.supervisorData?.LoginID);
        this.agentSelected.emit(this.supervisorData?.LoginID);
    }

    onSearchTermChange(event: string): void {
        this.searchTerm = event.trim().toLowerCase();
        this.searchSubject.next(this.searchTerm);
    }
    
    applySearchFilter(): void {
        const supervisorsArray = Array.isArray(this.supervisorData) ? this.supervisorData : [this.supervisorData];
        if (!this.searchTerm) {
            this.filteredSupervisors = supervisorsArray;
        } else {
            this.filteredSupervisors = supervisorsArray.filter(supervisor =>
                supervisor.LoginName?.toLowerCase().includes(this.searchTerm) ||
                supervisor.GroupName?.toLowerCase().includes(this.searchTerm)
            );
        }
        this.changeDetector.detectChanges();
    }

    onSeeMoreOpened(isOpen: boolean) {
        //Used to update the flag to check if the see morve view is opened
        this.seeMoreStatus.emit(isOpen);
    }

    onAgentUpdated(agent) {
        //Update the agent information from the see more view
        this.agentUpdated.emit(agent);
    }
}
